const backgroundStyles = {
  gradientWithCurves1: 'Gradient With Curves 1',
  gradientWithCurves2: 'Gradient With Curves 2',
  gradientWithCurves3: 'Gradient With Curves 3',
  gradient1: 'Gradient 1',
  gradient2: 'Gradient 2',
  midnightGradient: 'Midnight',
}

export default backgroundStyles
